import {AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid, parseOptions} from '../question-helper';
import { SlickCarouselComponent } from "ngx-slick-carousel";
import { HostListener } from "@angular/core";

declare var $: any;

@Component({
    selector: 'app-question-traffic-cop',
    templateUrl: './question-traffic-cop.component.html',
    styleUrls: ['./question-traffic-cop.component.scss'],
    standalone: false
})

export class QuestionTrafficCopComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() labelText = '';
  @Input() placeHolderText = '';
  @Input() value = '';
  @Input() showToolTip = true;
  @Input() toolTipContent = 'To change this answer you need to restart or contact us';
  @Input() toolTipPlacement = 'bottom';
  @Input() isToolTipContentHtml = false;
  @Input() items: any[] = [];
  @Input() selectedOption: any;
  @Output() questionAnswer = new EventEmitter();
  @Output() showEditModal = new EventEmitter<any>();
  @ViewChild("slickModal") slickModal: SlickCarouselComponent;
  

  grouping: any[] = [];
  uniqueControlName = `textbox-${newGuid()}`;
  uniqueId = `textbox-${newGuid()}`;
  slideConfig = {
    dots: true,
    arrows: true,
    fade: true,
    speed: 400,
   // variableWidth: true, //slide breaks without this
    cssEase: "ease-in",
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    rows: 0
  };
  constructor(private questionService: GlobalQuestionService) {
    
  }
  
  ngOnInit(): void {
    if (this.question?.options?.length) {
      this.items = parseOptions(this.question.options);
      this.items.forEach(i => {
        if (!this.grouping.includes(i.group_name))
          this.grouping.push(i.group_name);
      });
    } else if (!this.items?.length) {
      this.items = [{answer: 'Yes'}, {answer: 'No'}];
    }
    if (this.question?.answer) {
      for (const q of this.items) {
        if (q === this.question?.answer) {
          //this.checkRadio(q.answer);
        }
      }
    } else {
      //this.checkRadio(this.items[0].answer);
    }
    console.log(this.items, this.grouping)
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      this.items = parseOptions(this.question?.options);
    } else if (changes?.items?.currentValue) {
      this.items = changes?.items?.currentValue;
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
    if (changes?.selectedOption?.currentValue !== changes?.selectedOption?.previousValue) {
      this.selectedOption = changes?.selectedOption?.currentValue;
    }
  }
  checkRadio(level: any): void {
    $('.custom-traffic:not(".is-included"):not(".is-active")')
               .removeClass('is-checked')

               // and uncheck any groups
               .closest('.custom-traffic__group')
               .removeClass('is-checked');
    $(`.${level.cent_aq_answer_id}`).addClass('is-checked');
    if (this.question) {
      this.question.answer = level.answer;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(level.answer);
    }
    //console.log(this.question,level);
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      //this.initSliders();
      this.questionService.initPopoverCustomize();
    }, 1000);
    
  }
 getGroupingLevel(group: any, l: any): any {
  return this.items.filter(g => g.group_name === group && g.parent_answer_id === l.cent_aq_answer_id);
 }
 getItk(l: any): any {
  if (!l) return [];
  if (l._itkParsed !== undefined) {
    return l._itkParsed;
  }
  try{
    l._itkParsed = JSON.parse(l.itk);
  }
  catch{
    l._itkParsed = [];
  }
  return l._itkParsed;
 }
  upperCase(): void {
    if (this.question?.cent_aq_question_id === 57 || this.question?.cent_aq_question_id === 2501) {
      this.value = this.value.toUpperCase();
    }
  }

  saveValue(): void {
    if (this.question) {
      this.question.answer = this.value;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(this.value);
    }
  }

  initSliders(): void {
         var accordionsOpen = false;
      // only listen for non-included and non-activated controls
      $(document).on('click', '.custom-traffic:not(".is-included"):not(".is-active") .custom-traffic__label', function(){
         
         var $controlLabel = $(this);
         var $control = $controlLabel.closest('.custom-traffic');
         var $controlGroup = $control.closest('.custom-traffic__group');
      
         // if not already checked
         // and if no active controls of the same name exist
         if( !$control.hasClass('is-checked') ){

            // find other controls, and uncheck 'em all 
            $('.custom-traffic:not(".is-included"):not(".is-active")')
               .removeClass('is-checked')

               // and uncheck any groups
               .closest('.custom-traffic__group')
               .removeClass('is-checked');

            // check control
            $control.addClass('is-checked');

            // and check active group if exists
            if($controlGroup){
               $controlGroup.addClass('is-checked');
            }

         } else {

            // uncheck control
            $control.removeClass('is-checked');

            // and and uncheck group if exists
            if($controlGroup){
               $controlGroup.removeClass('is-checked');
            }

         }         

      });
    
      // on remove of active item...
      // convert to standard state
      var $itemToDeactivate = null;            

      // $('#remove-alert-modal').on('show.bs.modal', function(e){
      //    var $trigger = $(e.relatedTarget);
      //    $itemToDeactivate = $trigger.closest('.custom-traffic');
      // });

      // $(document).on('click', '#remove-cover-btn', function(e){       
      //    $itemToDeactivate
      //       .removeClass('is-active')
      //       .find('.custom-traffic__indi').html('<span class="fake-radio"></span>');

      //    $itemToDeactivate.closest('.custom-traffic__group')
      //       .removeClass('is-active').removeClass('is-checked')
      //       .find('.custom-traffic--child').removeClass('is-active').removeClass('is-checked');            
      // });
      

      // sliders
      $('.slider--traffic').each(function(){
        var $slider = $(this);

    //     // $slider.slick({
    //     //    dots: true,
    //     //    arrows: true,
    //     //    fade: true,      
    //     //    speed: 400,
    //     //    cssEase: "ease-in",   
    //     //    infinite: false,
    //     //    slidesToShow: 1,  
    //     //    slidesToScroll: 1,    
    //     //    swipeToSlide: true,
    //     //    prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    //     //    nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    //     //    rows: 0 
    //     // });

    //     // carousel refresh on accordion open (else it's all broken-like ...probably fine when using angular version tho)
        $slider.closest('.accordion__body').on('show.bs.collapse', function (e) {
          // $slider.slick('refresh'); 
           accordionsOpen = true;            
        });
        

     });
   
  }
  reloadQuestion(q:any): void {
    this.grouping = [];
    this.question = q;
    this.items = parseOptions(q?.options);
    console.log(this.items);
    setTimeout(() => {
      //this.questionAnswer.emit(q);
    }, 5000);
    
    //this.ngOnInit();
    //window.location.reload();
    //this.questionAnswer.emit(this.question);
    // this.items.forEach(i => {
    //   if (!this.grouping.includes(i.group_name))
    //     this.grouping.push(i.group_name);
    // });
  }

  editModal(event: any): void {
    this.questionService.spinner(true);
    let collation: any;
      this.questionService.updatePrices(this.question?.product_id, this.question?.product_class_id, 0)
        .subscribe(x => {
          this.questionService.getPageData('quote')
            .subscribe(dataset => {
              let product = this.questionService.getIndexData(4, dataset)[0];              
              let person = this.questionService.getIndexData(1, dataset)[0];
              let collations = this.questionService.getIndexData(2, dataset);
              if (!event.item_id){
                event.item_id = 1
              }
              collation = collations.find(c => c.class_id === event?.class_id && c.session_item_id.toString() === event?.item_id.toString() && c.product_id === product?.product_id);
              console.log('item', event);
              console.log('collation', collation);
              console.log('collations', collations);

              this.showEditModal.emit({
                collations: collations,
                collation,
                product: product,
                person: person,
                path: '3'
              });
            }, error => {
              console.log(error);
              this.questionService.spinner(false);
            });
        }, () => {
          this.questionService.spinner(false);
        });
    
  }
}
